import { Application } from 'pixi.js';
import React, { useEffect, useState } from 'react';
import { Game } from './Game';
import styles from './GameComponent.scss';

// REDUX & MANAGERS
import { useAppDispatch } from '@Managers/Redux/Hooks';

// TOOLS
import { getDevicePixelRatio } from '@Tools/DevicePixelRatio';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import { setGamePerformance, setCanvasReady } from '@Managers/Redux/AppState/AppState';

export let gameInstance: Game;

const GameComponent = () => {
    const dispatch = useAppDispatch();
    let lastPerformanceCheck = performance.now();
    useEffect(() => {
        const initGame = async () => {
            const app = new Application();
            gameInstance = new Game(app);

            await app.init({
                width: window.innerWidth,
                height: window.innerHeight,
                background: '#000000',
                antialias: false,
                resolution: getDevicePixelRatio(),
                autoDensity: true,
                backgroundAlpha: 1,
                resizeTo: window,
                sharedTicker: false,
                autoStart: false
            });

            const container = document.getElementById('app--game-container');

            if (container) {
                container.appendChild(app.canvas);
            }

            await gameInstance.initPIXI();

            gameInstance.gameTicker.add(() => {
                if (ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER)?.debugTools?.active) {
                    const performanceTest = {
                        targetFps: 60,
                        actualFps: +gameInstance.fpsTracker.getAverageFPS().toFixed(2),
                        fpsVsTarget: '',
                        deltaVsTarget: '',
                        frame: 0,
                        delta: +gameInstance.gameTicker.deltaMS.toFixed(2),
                        rawDelta: gameInstance.gameTicker.deltaMS
                    };
                    if (performanceTest) dispatch(setGamePerformance(performanceTest));
                }
            });

            const resizeObserver = new ResizeObserver((entries) => {
                gameInstance.onResize();
            });

            window.addEventListener('orientationchange', () => {
                gameInstance.onResize();
            });

            resizeObserver.observe(app.canvas);

            dispatch(setCanvasReady(true));
        };

        initGame();
    }, []);

    return <div id="app--game-container" className={styles.game__container}></div>;
};

export default GameComponent;
